import script from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=ae35a2f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae35a2f6"]])

export default __exports__